import { type PersistentStorage } from 'apollo3-cache-persist';
import { type EncryptStorage } from 'encrypt-storage';

/**
 * Custom persist storage wrapper for EncryptStorage which encrypts the data
 * before saving and decrypts when retrieving.
 */
export class EncryptStorageWrapper implements PersistentStorage<string | null> {
	private storage: EncryptStorage;

	constructor(storage: EncryptStorage) {
		this.storage = storage;
	}

	getItem(key: string): string | null {
		try {
			return this.storage.getItem(key) ?? null;
		} catch (e) {
			return null;
		}
	}

	removeItem(key: string): void {
		return this.storage.removeItem(key);
	}

	setItem(key: string, value: string | null): void {
		if (value !== null) {
			// setting null to sessionstorage stores "null" as string
			return this.storage.setItem(key, value);
		}
		return this.removeItem(key);
	}
}
